import React from 'react';
import { Flex, Spinner, Text } from '@chakra-ui/react';
import { DataSkeleton, DataSkeletonVariant } from '../states';

interface LoaderProps {
  variant?: DataSkeletonVariant;
  label?: string;
  fullScreen?: boolean;
}

const Loader = ({ variant, label = 'Carregando conteúdo', fullScreen = false }: LoaderProps) => {
  if (fullScreen) {
    return (
      <Flex
        role="status"
        aria-label={label}
        aria-busy="true"
        minH="100vh"
        w="full"
        direction="column"
        align="center"
        justify="center"
        gap="12px"
        bg="surface.canvas"
      >
        <Spinner size="md" color="content.subtle" thickness="2px" speed="0.7s" />
        <Text fontSize="13px" color="content.subtle">
          {label}
        </Text>
      </Flex>
    );
  }

  return <DataSkeleton variant={variant ?? 'form'} rows={6} label={label} />;
};

export default Loader;
